/**
 * The reset and save buttons in the detailed view
 */
import React from 'react'
import TouchButton from '../../utils/ope-touch-button'
import EditorActions from '../../../actions/editor-actions'
import createReactClass from 'create-react-class'


var DetailedOptions = createReactClass({
	handleResetTap: function() {
		if (this.props.item.optionsStored) {
			EditorActions.cancelItemChanges(this.props.item);
		}
	},

	handleSaveTap: function() {
		this.props.saveCallback();
	},

	render: function() {
		return (
			<ul className="row ope-editor__detailed__options">
				<li className="small-6 columns">
					<TouchButton className="button small secondary" onTap={this.handleResetTap}>{_("Reset")}</TouchButton>
				</li>
				<li className="small-6 columns">
					<TouchButton className="button small secondary l-right" onTap={this.handleSaveTap}>{_("Save")}</TouchButton>
				</li>
			</ul>
		);
	}
});

export default DetailedOptions;
